import '.ao{position:relative;}.ssr-plugin'
import '.ii{width:64px;}.ssr-plugin'
import '.ij{height:64px;}.ssr-plugin'
import '.ar{flex-shrink:0;}.ssr-plugin'
import '.bs{position:absolute;}.ssr-plugin'
import '.ik{bottom:-4px;}.ssr-plugin'
import '.ig{right:-4px;}.ssr-plugin'
import '.g6{border-radius:50%;}.ssr-plugin'
import '.ci{border:2px solid var(--palette-white);}.ssr-plugin'
import '.bg{overflow:hidden;}.ssr-plugin'
import '.il{width:32px;}.ssr-plugin'
import '.im{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="ao ii ij ar"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="bs ik ig g6 ci bg il im"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
